import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SlideBar from "./SlideBar";

const DefaultLayout = () => {
  return (
    <div>
      <Header />
      <SlideBar/>
      <Outlet />
      <Footer />
    </div>
  );
};

export default DefaultLayout;
